import { defineResolver } from 'customer-flows/utils/quote/resolvers'

export default {
  // for per-booking questions
  questionAnswers: defineResolver<QuoteSparseQuestionAnswerInput[]>(({ resolveStoreProp }) => ({
    resolve: () => {
      return resolveStoreProp('custom-question', 'perBookingQuestionAnswers')
    },
    traits: {
      nonMandatory: () => {
        return resolveStoreProp('custom-question', 'nonMandatoryPerBookingQuestionAnswers')
      }
    }
  })),

  // for per-guest questions, answers are nested inside tickets
  perGuestQuestionAnswers: defineResolver<Map<string, QuoteSparseQuestionAnswerInput[]>>(({ resolveStoreProp }) => ({
    resolve: () => {
      return resolveStoreProp('custom-question', 'perGuestQuestionAnswers')
    },
    traits: {
      nonMandatory: () => {
        return resolveStoreProp('custom-question', 'nonMandatoryPerGuestQuestionAnswers')
      }
    }
  }))
}

